<template>
  <div class="add-ons-container">
    <div class="add-ons-header">
      <h2 class="title">
        Add-ons
        <VideoHoverPlayer title="Add-ons" videoUrl="https://player.vimeo.com/video/1146586965" />
      </h2>
    </div>

    <div class="add-ons-list">
      <!-- Special Courses -->
      <!-- <div
        v-for="special in specialCoursesList"
        :key="special.id"
        class="add-on-item"
      >
        <div class="checkbox-container">
          <input
            type="checkbox"
            :id="special.id"
            :checked="isCourseSelected(special.courseId)"
            @change="handleSpecialCourse(special, $event)"
          />
          <label :for="special.id" class="custom-checkbox"></label>
        </div>

        <div class="add-on-wrapper">
          <div class="add-on-content">
            <div class="add-on-title">
              <h3>{{ special.title }}</h3>
              <p>{{ special.description }}</p>
            </div>
          </div>
          <div class="add-on-price">
            <span class="price">${{ special.price.toFixed(2) }}</span>
            <span class="period">Per month</span>
          </div>
        </div>
      </div> -->

      <div
        class="add-on-item"
        v-for="(addon,key, index) in addons_config"
        :key="key"
      >
        <div class="checkbox-container">
          <input
            type="checkbox"
            :id="key"
            v-model="selectedAddOns[key]"
            @change="emitSelectedAddOns"
          />
          <label :for="key" class="custom-checkbox"></label>
        </div>
        <div class="add-on-wrapper">
          <div class="add-on-content">
            <div class="add-on-title">
              <h3>{{ addon.label }}</h3>
              <p>{{ addon.description }}</p>
            </div>
          </div>

          <div class="add-on-price">
            <span class="price">${{ addon.price.toFixed(2) }}</span>
            <span class="period">{{ addon.unit }}</span>
          </div>
        </div>
      </div>

    </div>

  <modal :show.sync="showUserModal">
    <h4
      slot="header"
      class="title title-up text-center"
      style="color: #444c57"
    >
      {{ specialCourseName }}
    </h4>
    <div class="col-md-8 mx-auto">
      <base-input
        label="How many users will be taking this course:"
        type="number"
        min="1"
        :key="specialCourseName"
        v-model.number="courseUser"
      />
    </div>
    <div class="col-md-6 mx-auto mt-3 text-center">
      <base-button
        size="md"
        class="custom-btn"
        style="background-color: #e66412; color: white; border-color: #e66412"
        @click="confirmSpecialCourse"
      >
        Done
      </base-button>
    </div>
  </modal>
  </div>
</template>
<script>
import VideoHoverPlayer from "@/components/Signup/VideoHoverPlayer.vue";
export default {
  name: "AddOns",
  components: { VideoHoverPlayer },
  props: {
    users: { type: Number,required: true },
    selectedSpecialCourses: { type: Array,required: true },
  },
  data() {
    return {
      selectedAddOns: {
        hours_safety: false,
        upload_training: false,
        sms_support: false,
        call_location: false,
        surveys: false,
        on_boarding: false,
      },
      addons_config: {
        hours_safety: {
          label: '24-Course Safety Training',
          description: 'Essential safety training to reduce injury risk',
          price: 3.0,
          type: 'flat', // fixed price
          image: 'img/price/food-manager.svg',
          unit: 'Per month',
        },
        upload_training: {
          label: 'Create Your own Courses',
          description: 'Create and train with your own courses',
          price: 10.0,
          type: 'uploadTraining', // course-based
          image: 'img/price/upload_your_own.svg',
          unit: 'Per month , Per 10 Courses',
        },
        sms_support: {
          label: 'SMS Notifications',
          description: 'Course and company required notifications',
          price: 9.00,
          type: 'perUser', // 100 users unit handled in backend
          image: 'img/price/sms_support.svg',
          unit: 'Per month , Per 100 users',
        },
        call_location: {
          label: 'Call Location',
          description: 'Quarterly service calls',
          price: 4.0,
          type: 'perLocation',
          image: 'img/price/customer_service_skills.svg',
          unit: 'Per month , Per Location',
        },
        surveys: {
          label: 'Surveys',
          description: 'Gather anonymous feedback',
          price: 5.0,
          type: 'perUser50', // per 50 users
          image: 'img/price/food-manager.svg',
          unit: 'Per 50 Users',
        },
        on_boarding: {
          label: 'Onboarding',
          description: 'Uploading team members',
          price: 3.0,
          type: 'perLocation',
          image: 'img/price/human_trafficking.svg',
          unit: 'Per month , Per Location',
        },
      },
      localSelectedSpecialCourses : this.selectedSpecialCourses,
      // Modal states
      showUserModal: false,
      specialCourseId: null,
      specialCourseName: '',
      courseUser : this.users
    };
  },
  methods: {
    emitSelectedAddOns() {
      console.log(this.selectedAddOns)
      const selected = Object.keys(this.selectedAddOns).filter(
        (key) => this.selectedAddOns[key]
      );
      this.$emit("add-ons-selected", selected);
    },
    // 🔹 Check if special course is selected
    isCourseSelected(courseId) {
      return this.localSelectedSpecialCourses.some((c) => c.id === courseId);
    },

    handleSpecialCourse(special, event) {
      if (event.target.checked) {
        // Open modal
        this.specialCourseId = special.courseId;
        this.specialCourseName = special.title;
        this.showUserModal = true;
      } else {
        // Remove special course
        this.localSelectedSpecialCourses = this.localSelectedSpecialCourses.filter(
          (c) => c.id !== special.courseId
        );
        this.emitSpecialCourses();
      }
    },

    confirmSpecialCourse() {
      console.log('confirm');
      const course = this.specialCoursesList.find(
        (c) => c.courseId === this.specialCourseId
      );
      if (!course) return;

      const existing = this.localSelectedSpecialCourses.findIndex(
        (c) => c.id === course.id
      );
      const courseObj = {
        id: course.courseId,
        name: course.title,
        users: this.courseUser,
      };

      if (existing !== -1)
        this.localSelectedSpecialCourses.splice(existing, 1, courseObj);
      else this.localSelectedSpecialCourses.push(courseObj);

      this.emitSpecialCourses();
      this.resetModal();
    },

    // 🔹 Emit special courses
    emitSpecialCourses() {
      this.$emit('update-special-courses', [...this.localSelectedSpecialCourses]);
    },

    // 🔹 Reset modal
    resetModal() {
      this.showUserModal = false;
      this.users = 1;
      this.specialCourseId = null;
      this.specialCourseName = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.add-ons-container {
  max-width: 1000px;
  margin: 0 auto;
}

.add-ons-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title {
  font-size: 20px;
  line-height: 25px;
  font-weight: 700;
  color: #252525;
  display: flex;
  align-items: center;
  gap: 10px;
}

.play-icon {
  display: none;
}

.add-ons-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.add-on-item {
  display: flex;
  align-items: center;
  border: 1px solid rgba(235, 26, 38, 0.2);
  border-radius: 12px;
  background-color: #fff;
  position: relative;
  .checkbox-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 10px;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
  }
  .add-on-wrapper {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 14px;
    .add-on-content {
      display: flex;
      align-items: center;
      gap: 12px;
      img {
        width: 28px;
        height: 28px;
      }
      .add-on-icon {
        margin-right: 16px;
        width: 48px;
        height: 48px;
      }
      .add-on-title {
        display: flex;
        flex-direction: column;
        h3 {
          font-size: 14px;
          line-height: 18px;
          font-weight: 700;
          margin: 0;
          color: #252525;
        }
        p {
          font-size: 10px;
          line-height: 15px;
          color: #252525;
          margin: 0;
        }
      }
    }
    .add-on-price {
      text-align: right;
      display: flex;
      flex-direction: column;
      min-width: fit-content;
      .price {
        font-size: 16px;
        line-height: 20px;
        font-weight: 700;
        color: #000;
      }
      .period {
        font-size: 12px;
        line-height: 15px;
        color: #252525;
      }
    }
  }
}

.checkbox-container input[type="checkbox"] {
  display: none;
}

.custom-checkbox {
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 2px solid #e5e7eb;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  margin-bottom: 0;
}

.checkbox-container input[type="checkbox"]:checked + .custom-checkbox {
  background-color: #ff5c35;
  border-color: #ff5c35;
}

.checkbox-container input[type="checkbox"]:checked + .custom-checkbox::after {
  // content: "url('/assets/icons/checked-icon.svg')";
  content: "";
  position: absolute;
  left: 8px;
  top: 4px;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

@media (min-width: 768px) {
  .title {
    font-size: 32px;
    line-height: 40px;
    font-weight: 700;
    color: #252525;
    gap: 10px;
  }

  .play-icon {
    display: block;
  }

  .add-ons-container {
    margin-top: 60px;
  }
  .add-on-item {
    display: flex;
    align-items: center;
    border: 1px solid rgba(235, 26, 38, 0.2);
    border-radius: 12px;
    background-color: #fff;
    position: relative;
    .checkbox-container {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px 18px;
      border-right: 1px solid rgba(0, 0, 0, 0.2);
    }
    .add-on-wrapper {
      flex: 1;
      padding: 24px 17px;
      .add-on-content {

        gap: 12px;
        img {
          width: 40px;
          height: 40px;
        }
        .add-on-icon {
          margin-right: 16px;
          width: 48px;
          height: 48px;
        }
        .add-on-title {
          h3 {
            font-size: 20px;
            line-height: 25px;
            font-weight: 700;
            margin: 0;
            color: #252525;
          }
          p {
            font-size: 16px;
            line-height: 20px;
            color: #252525;
            margin: 0;
          }
        }
      }
      .add-on-price {
        .price {
          font-size: 18px;
          line-height: 24px;
        }
        .period {
          font-size: 14px;
          line-height: 18px;
        }
      }
    }
  }
}
</style>
